// Module
var code = `<!-- ko if: !isUploading && !\$data.koIsEmptyImageLink() -->
<div class="svc-image-question-controls">
  <!-- ko if: (allowEdit) -->
  <input type="file" aria-hidden="true" tabindex="-1" class="svc-choose-file-input" data-bind="attr: { accept: acceptedTypes }">
  <sv-svg-icon class="svc-context-button" data-bind="click: chooseFile, key2click" params="iconName: 'icon-choosefile', size: 'auto'"></sv-svg-icon>
  <!-- /ko -->
</div>
<!-- /ko -->
<!-- ko if: isUploading && !\$data.koIsEmptyImageLink() -->
<div class="svc-image-question__loading-placeholder">
  <div class="svc-image-question__loading">
    <!-- ko component: { name: 'sv-loading-indicator' } -->
    <!-- /ko -->
  </div>
</div>
<!-- /ko -->`;
// Exports
export default code;